import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/shared/inputs/ResourceSelect";
import WeekdaySelect from "../../../../../../components/shared/inputs/WeekdaySelect";
import { Field } from "../../../../../../components/shared/Form";
import { useScheduleContext } from "../../../hooks/context/useScheduleContext";
import { getUserSearchFilters } from "../../../../../People/useColumns";
import { renderUserName } from "../../../../../../utils/helpers/user";
import { firstToUpper } from "../../../../../../utils/helpers/string";
import type { CopyValues } from "./types";

interface TemplateProps {
    values: CopyValues | null;
}

function Template({ values }: TemplateProps) {
    const { t } = useTranslation();
    const { type } = useScheduleContext();

    return (
        <div>
            {["template", "profile"].includes(type) && (values?.type === "row" || values?.type === "cell") && (
                <Field
                    name="users"
                    label={t("select-one-or-more-employees-to-copy")}
                >
                    <ResourceSelect
                        resourcePath="/users"
                        renderLabel={renderUserName}
                        placeholder={t("users")}
                        mode="multiple"
                        getSearchFilter={getUserSearchFilters}
                    />
                </Field>
            )}

            <Field
                name="day"
                label={firstToUpper(t("day"))}
            >
                <WeekdaySelect
                    placeholder={firstToUpper(t("day"))}
                    mode={values?.type === "row" ? "multiple" : "single"}
                />
            </Field>
        </div>
    );
}

export default Template;
